// extracted by mini-css-extract-plugin
module.exports = {"imgRoton":"Roton_imgRoton__3n3iA","h3_init":"Roton_h3_init__JO9ir","content_init":"Roton_content_init__LJHv2","text_init":"Roton_text_init__39GdL","center":"Roton_center__2wu4V"};